import React from 'react'
import './fwlast.css'
const Fwlast = () => {
    return (
        <section id='fwlast'>
            <div className="container d-flex justify-content-center">
                <div className="last-box">
                    <div className='border-bottom history'><h1>Transaction history</h1></div>
                    <div className='swiggy-wrap border-bottom'>
                        <div>
                            <img src="./images/Foodcardwallet/Swiggy-last.svg" alt="" />
                        </div>
                        <div>
                            <p>Swiggy 50% coupon </p>
                        </div>
                        <div>
                            <p>300/-</p>
                        </div>
                    </div>
                    <div className='swiggy-wrap border-bottom'>
                        <div>
                            <img src="./images/Foodcardwallet/Swiggy-last.svg" alt="" />
                        </div>
                        <div>
                            <p>Swiggy 50% coupon </p>
                        </div>
                        <div>
                            <p>300/-</p>
                        </div>
                    </div>
                    <div className='swiggy-wrap border-bottom'>
                        <div>
                            <img src="./images/Foodcardwallet/Swiggy-last.svg" alt="" />
                        </div>
                        <div>
                            <p>Swiggy 50% coupon </p>
                        </div>
                        <div>
                            <p>300/-</p>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                    <div className='view-more-btn'>
                           <h5>View More</h5>
                    </div>
                    </div>
                    
                </div>

            </div>
        </section>
    )
}

export default Fwlast